// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__bFzGX","title":"Info_title__1zySG","selects":"Info_selects__1ZDtm","requiredAsterisk":"Info_requiredAsterisk__Z4zoj"};